import Dayjs from "dayjs";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/es";
import "moment/locale/pt";

import I18nService from "Services/i18n";
import { DEFAULT_TIME_ZONE } from "Services/statistic";

const ADP_START_DATE = moment("2014-10-30");
const STORAGE_KEY = "tz";

export function getTimeForServer(value) {
  return moment(value).format("YYYY-MM-DD");
}

export function getTimeForDatePicker(value) {
  return moment(value);
}

const lang = I18nService.getDefaultLanguage();

moment.locale(lang === "pt_br" ? "pt" : lang);

export function getTimeForClient(value, unix = false, format = "DD.MM.YYYY") {
  if (typeof value === "object") {
    return value;
  }

  if (unix) {
    return Dayjs.unix(value).format(format);
  }
  return Dayjs(value).format(format);
}

export function getUnixTime(value) {
  return Dayjs(value).unix();
}

export function withGreaterThanADPStartDate(value) {
  return value.isBefore(ADP_START_DATE) ? ADP_START_DATE : value;
}

export function isLastSevenDays(value) {
  return Dayjs(value).isAfter(Dayjs().subtract(7, "day"));
}

export function saveTimeZone(value) {
  window.localStorage.setItem(STORAGE_KEY, value);
}

export function getTimeZone() {
  const restoredTimeZone = window.localStorage.getItem(STORAGE_KEY);
  if (restoredTimeZone === null) {
    return DEFAULT_TIME_ZONE;
  }

  return restoredTimeZone;
}

export function timezoneOffset(date) {
  let sign = date.getTimezoneOffset() > 0 ? "-" : "+";
  let offset = Math.abs(date.getTimezoneOffset());
  let hours = Math.floor(offset / 60);
  return `GMT${sign}${hours}`;
}

export function utcToLocal(utcDateTime, format = "DD.MM.YYYY HH:mm") {
  const local = () => moment.utc(utcDateTime).local();
  const formatted = () => local().format(format);

  const date = () =>
    isCurrentDate
      ? I18nService.getStringByKey("today")
      : formatted().split(" ")[0];

  const time = () =>
    formatted().split(" ")[1] + " " + timezoneOffset(new Date(local()));

  const timeWithoutZone = () => formatted().split(" ")[1];

  const full = () => date() + " " + time();

  const isCurrentDate = local().isSame(new Date(), "day");

  return {
    full: full,
    date: date,
    time: time,
    local: local,
    formatted: formatted,
    timeWithoutZone,
  };
}
